export default {"src":"/_next/static/media/x.c3b5de1f.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};